exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3CdRdPRXNlaG-F{display:block;color:#fff;padding:10px 8px 10px 38px;font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-weight:400;display:flex;flex-direction:row;justify-content:left;align-items:center;margin:0}._2j-nbatqtDppQo{box-shadow:0 1px 1px rgba(9,30,66,.25),0 0 0 1px rgba(9,30,66,.08)}._3JG7awZST92MWl{border-radius:3px}._2d7mdigvlEAIv7{padding:7px 15px}._4P64DwKiSCfMVT{cursor:pointer}._4P64DwKiSCfMVT._3n8nbyHYnPtADL{align-self:flex-start}.sNWp2nYx_tT6jY{padding-right:25px;flex-grow:1;color:#172b4d;font-size:14px;line-height:24px}.sNWp2nYx_tT6jY a{color:#172b4d}.sNWp2nYx_tT6jY.D_p4h30A2EmHlk,.sNWp2nYx_tT6jY.D_p4h30A2EmHlk a{color:#fff}", ""]);

// exports
exports.locals = {
	"bannerContainer": "_3CdRdPRXNlaG-F",
	"bannerShadow": "_2j-nbatqtDppQo",
	"roundedCorners": "_3JG7awZST92MWl",
	"inlinePadding": "_2d7mdigvlEAIv7",
	"closeButton": "_4P64DwKiSCfMVT",
	"alignTop": "_3n8nbyHYnPtADL",
	"textContent": "sNWp2nYx_tT6jY",
	"lightText": "D_p4h30A2EmHlk"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/common/components/banner/banner.less
// module id = Sbsc
// module chunks = 24